/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "DeleteCatalogObjectRequest": {
                        "fields": {
                          "objectId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "DeleteCatalogObjectResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "deletedObjectIds": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "deletedAt": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.DeleteCatalogObjectRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.DeleteCatalogObjectResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeleteCatalogObjectRequest @ squareup/connect/v2/catalog/interfaces/delete-catalog-obj.proto at 18:1
 */
export const DeleteCatalogObjectRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.DeleteCatalogObjectRequest');
fixType(DeleteCatalogObjectRequest, {
  objectId: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(DeleteCatalogObjectRequest);
/**
 * SOURCE DeleteCatalogObjectResponse @ squareup/connect/v2/catalog/interfaces/delete-catalog-obj.proto at 31:1
 */
export const DeleteCatalogObjectResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.DeleteCatalogObjectResponse');
fixType(DeleteCatalogObjectResponse);
Builder.createAndAttachToType(DeleteCatalogObjectResponse);